'use client'
/**
 * Dernier filet : erreur dans un layout racine (espace, votes, quiz,
 * parrainage…). Remplace la page anglaise par défaut de Next.js par un
 * message en français. Doit fournir ses propres balises <html> et <body>.
 */
import ErreurAutonome from './erreur-autonome'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="fr">
      <body style={{ margin: 0, background: '#fff' }}>
        <ErreurAutonome error={error} reset={reset} retour={{ href: '/', libelle: 'Accueil' }} />
      </body>
    </html>
  )
}
